import { create, filter, findOne, update, findAll } from "@/store/Crud/functions/actions";
import { archive } from "@/store/Crud/functions/archived/actions";

import { ActionTree } from "vuex";
import { State } from "./state";
import { ICrudOptions } from "@/interfaces/ICrudOptions";
import axios from "@/utils/axios";

export async function revertToDefault(store: any, options: ICrudOptions): Promise<any> {
  return axios.post(`${options.resource}/${options.id}/revert-to-default`);
}

// Bypasses the shared IS_LOADING/dataList state so saving one card never flashes the whole grid's overlay
// or triggers a full re-fetch; the card fetches its own fresh copy via findGroupById once the save resolves.
export async function saveGroup(store: any, options: ICrudOptions): Promise<any> {
  return axios.put(`${options.resource}/${options.id}`, options.data);
}

export async function findGroupById(store: any, options: ICrudOptions): Promise<any> {
  return axios.get(`${options.resource}/${options.id}`);
}

export default <ActionTree<State, any>>{
  findAll,
  findOne,
  update,
  create,
  filter,
  archive,
  revertToDefault,
  saveGroup,
  findGroupById,
};
